import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { AllowedPeriods } from './allowedPeriods';

class AuditDashboardStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    selectedPeriod: AllowedPeriods;

    // TODO add all bindings

    static $inject = [];
}

export const wtAuditDashboardState: ComponentDefinition = {
    componentId: 'wtAuditDashboardState',
    controller: AuditDashboardStateController,
    template: require('./auditDashboardState.component.html'),
    controllerAs: 'vm',
    bindings: {
        beginDate: '<',
        endDate: '<',
        isLoading: '<',
        tickets: '<',
        ticketStatuses: '<',
        selectedPeriod: '<?'
    }
};

